export const drawer = { label: "Diário", href: "/diario" };
